import { apiClient } from './client';

export interface FolderItem {
  id: string;
  folderId: string;
  channelId: string | null;
  peerUserId: string | null;
}

export interface Folder {
  id: string;
  userId: string;
  name: string;
  emoji: string | null;
  position: number;
  rules: unknown | null;
  createdAt: string;
  items: FolderItem[];
}

export interface ArchivedChat {
  id: string;
  userId: string;
  channelId: string | null;
  peerUserId: string | null;
  archivedAt: string;
}

export interface PinnedChat {
  id: string;
  userId: string;
  channelId: string | null;
  peerUserId: string | null;
  position: number;
  pinnedAt: string;
}

export interface SavedItem {
  id: string;
  userId: string;
  messageId: string | null;
  dmId: string | null;
  note: string | null;
  tags: string[];
  createdAt: string;
}

type ChatRef = { channelId?: string; peerUserId?: string };

export const foldersApi = {
  list: () => apiClient.get<Folder[]>('/api/folders').then((r) => r.data),
  create: (data: { name: string; emoji?: string; position?: number; rules?: unknown }) =>
    apiClient.post<Folder>('/api/folders', data).then((r) => r.data),
  update: (folderId: string, data: { name?: string; emoji?: string; position?: number; rules?: unknown }) =>
    apiClient.put<Folder>(`/api/folders/${folderId}`, data).then((r) => r.data),
  delete: (folderId: string) => apiClient.delete(`/api/folders/${folderId}`).then(() => undefined),
  addItem: (folderId: string, ref: ChatRef) =>
    apiClient.post<FolderItem>(`/api/folders/${folderId}/items`, ref).then((r) => r.data),
  removeItem: (folderId: string, ref: ChatRef) =>
    apiClient.delete(`/api/folders/${folderId}/items`, { data: ref }).then(() => undefined),

  // Archive
  listArchive: () => apiClient.get<ArchivedChat[]>('/api/folders/archive/list').then((r) => r.data),
  archive: (ref: ChatRef) =>
    apiClient.post<ArchivedChat>('/api/folders/archive', ref).then((r) => r.data),
  unarchive: (ref: ChatRef) =>
    apiClient.delete('/api/folders/archive', { data: ref }).then(() => undefined),

  // Pinned chats
  listPinned: () => apiClient.get<PinnedChat[]>('/api/folders/pinned/list').then((r) => r.data),
  pinChat: (ref: ChatRef & { position?: number }) =>
    apiClient.post<PinnedChat>('/api/folders/pinned', ref).then((r) => r.data),
  unpinChat: (ref: ChatRef) =>
    apiClient.delete('/api/folders/pinned', { data: ref }).then(() => undefined),

  // Saved
  listSaved: (params?: { tag?: string; cursor?: string }) =>
    apiClient.get<SavedItem[]>('/api/folders/saved/list', { params }).then((r) => r.data),
  save: (data: { messageId?: string; dmId?: string; note?: string; tags?: string[] }) =>
    apiClient.post<SavedItem>('/api/folders/saved', data).then((r) => r.data),
  deleteSaved: (itemId: string) =>
    apiClient.delete(`/api/folders/saved/${itemId}`).then(() => undefined),
};
